var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "saleAnalysis" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { xl: 17, lg: 16 },
            },
            [
              _c("label", { staticStyle: { width: "70px" } }, [
                _vm._v(_vm._s(_vm.$t("sale-analysis::shopName"))),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    popperAppendToBody: false,
                    placeholder: _vm.$t("system::common::select_placeholder"),
                  },
                  on: { change: _vm.changeShop },
                  model: {
                    value: _vm.selectedShop,
                    callback: function ($$v) {
                      _vm.selectedShop = $$v
                    },
                    expression: "selectedShop",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c("el-option", {
                    key: item.shopId,
                    attrs: { label: item.shopName, value: item.shopId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { xl: 7, lg: 8 },
            },
            [
              _c("label", { staticStyle: { width: "150px" } }, [
                _vm._v(_vm._s(_vm.$t("sale-analysis::orderDate"))),
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  appendToBody: false,
                  clearable: false,
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": "~",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "picker-options": _vm.pickerOptions,
                },
                on: { change: _vm.handlerDateChange },
                model: {
                  value: _vm.selectDate,
                  callback: function ($$v) {
                    _vm.selectDate = $$v
                  },
                  expression: "selectDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "8px" },
              on: {
                click: function ($event) {
                  _vm.$router.push({ path: _vm.reportJumpUrl().salesReport })
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("system::common::btn::check_report")) + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "card-content", attrs: { gutter: 20 } },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item",
              attrs: { lg: 6, md: 6, sm: 12, xl: 6 },
            },
            [
              _c("dataCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.cardLoading,
                    expression: "cardLoading",
                  },
                ],
                attrs: { option: item, active: 0 },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reportCardLoading,
                    expression: "reportCardLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.saleTrendData },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.tableConfig },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopName",
                      label: _vm.$t("sale-analysis::station::table_shopName"),
                      "min-width": "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.shopName)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopType",
                      label: _vm.$t("sale-analysis::station::table_shopType"),
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.shopType)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "saleAmount",
                      label: _vm.$t("sale-analysis::station::table_sales"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.saleAmount)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "saleAmountPercentage",
                      label: _vm.$t("sale-analysis::station::table_salesRatio"),
                      "min-width": "125",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(
                                    scope.row.saleAmountPercentage
                                  ) + "%"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "visitClientCnt",
                      label: _vm.$t("sale-analysis::station::table_visitor"),
                      "min-width": "125",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.visitClientCnt)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "transRate",
                      label: _vm.$t(
                        "sale-analysis::station::table_changeRatio"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.transRate) + "%"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerPricePer",
                      label: _vm.$t(
                        "sale-analysis::station::table_customerPricePer"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.customerPricePer)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "associateRate",
                      label: _vm.$t(
                        "sale-analysis::station::table_associateRate"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.associateRate)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.salesTable,
                      expression: "loading.salesTable",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.salesTable },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "imageUrl",
                      label: _vm.$t("board::table_商品图片"),
                      "min-width": "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-image", {
                              staticClass: "goods-image",
                              attrs: { src: scope.row.imageUrl },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "spuId",
                      label: "spu_id",
                      "min-width": "100px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "saleQuantity",
                      label: _vm.$t("board::table_销量"),
                      "min-width": "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.saleQuantity)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "saleAmount",
                      label: _vm.$t("board::table_销售金额"),
                      "min-width": "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.saleAmount)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "refundAmount",
                      label: _vm.$t("board::table_退款金额"),
                      "min-width": "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.refundAmount)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stockQuantity",
                      label: _vm.$t("board::table_可用库存数量"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.stockQuantity)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerPricePer",
                      label: _vm.$t("board::table_客单价"),
                      "min-width": "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.customerPricePer)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.salesPieEchart,
                    expression: "loading.salesPieEchart",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.salesPieEchart },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.consumeTable,
                      expression: "loading.consumeTable",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.consumeTable },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: _vm.$t("board::table_顾客名称"),
                      "min-width": "150px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderNum",
                      label: _vm.$t("board::table_下单次数"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.orderNum)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalAmount",
                      label: _vm.$t("board::table_消费总额"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.totalAmount)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createDate",
                      label: _vm.$t("board::table_加入日期"),
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$dataCheck(scope.row.createDate)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastOrderDate",
                      label: _vm.$t("board::table_最近下单日期"),
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(scope.row.lastOrderDate)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.buyBarEchart,
                    expression: "loading.buyBarEchart",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.buyBarEchart },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }